import { render, staticRenderFns } from "./comprehensiveGrade.vue?vue&type=template&id=c912958c&"
import script from "./comprehensiveGrade.vue?vue&type=script&lang=js&"
export * from "./comprehensiveGrade.vue?vue&type=script&lang=js&"
import style0 from "./comprehensiveGrade.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports